import moment from "@/utils/moment";

function extractIcalPart(ical, regex) {
  const part = ical.match(regex);

  return part || null;
}

// Filters
const startTime = subscription => {
  const startTimePart = extractIcalPart(
    subscription.ical,
    /(?=DTSTART:).+?(?=\n)/
  );

  return startTimePart
    ? `${moment(startTimePart[0].split(":")[1]).hour()} hs`
    : "n/a";
};

export default {
  filters: {
    startTime
  }
};



// WEBPACK FOOTER //
// ./src/mixins/subscriptionMixin.js